import React, { FC } from 'react';
import { RootState, useSelector } from 'src/store';
import { changeEnterHTML } from 'src/utils/changeEnter';
import { getFontURL } from 'src/utils/getFontUrl';
import { trackingList } from 'src/utils/valueHTML';

const SlideModalImageHTML: FC = () => {
  const bgImage = useSelector((state: RootState) => state.imageUpload.bgImage);
  // let bgColor = useSelector((state: RootState) => state.imageUpload.bgColor);
  const deeplink = useSelector(
    (state: RootState) => state.imageUpload.deeplink
  );
  const radius = useSelector((state: RootState) => state.imageUpload.radius);

  const text = useSelector((state: RootState) => state.editText.text);
  const fontSize = useSelector((state: RootState) => state.editText.fontSize);
  const fontWeight = useSelector(
    (state: RootState) => state.editText.fontWeight
  );
  const color = useSelector((state: RootState) => state.editText.color);
  const fontFamily = useSelector(
    (state: RootState) => state.editText.fontFamily
  );
  const textAlign = useSelector((state: RootState) => state.editText.textAlign);

  const btnText = useSelector((state: RootState) => state.buttons.btnText);
  const btnFontSize = useSelector(
    (state: RootState) => state.buttons.btnFontSize
  );
  const btnFontWeight = useSelector(
    (state: RootState) => state.buttons.btnFontWeight
  );
  const btnColor = useSelector((state: RootState) => state.buttons.btnColor);
  const btnBgColorR = useSelector(
    (state: RootState) => state.buttons.btnBgColorR
  );
  const btnBgColorG = useSelector(
    (state: RootState) => state.buttons.btnBgColorG
  );
  const btnBgColorB = useSelector(
    (state: RootState) => state.buttons.btnBgColorB
  );
  const btnBgColorA = useSelector(
    (state: RootState) => state.buttons.btnBgColorA
  );
  const btnFontFamily = useSelector(
    (state: RootState) => state.buttons.btnFontFamily
  );
  // let btnRadius = useSelector((state: RootState) => state.buttons.btnRadius);

  const tracking = useSelector((state: RootState) => state.trackings.tracking);
  const button1 = useSelector((state: RootState) => state.trackings.button1);
  const button2 = useSelector((state: RootState) => state.trackings.button2);
  // let currentUser = useSelector((state: RootState) => state.client.userCompany);

  const multiTitleFontURL = getFontURL(fontFamily?.multi_title);
  const multiLeftButtonFontURL = getFontURL(btnFontFamily?.multi_left_button);
  const multiRightButtonFontURL = getFontURL(btnFontFamily?.multi_right_button);
  // const multiTitleFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${fontFamily?.multi_title}`;
  // const multiLeftButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_left_button}`;
  // const multiRightButtonFontURL = `https://workspace.inappmessage.com/${currentUser}/font/${btnFontFamily?.multi_right_button}`;
  const blackImageUrl = 'https://i.ibb.co/mSdNZgM/Frame-103.png';
  const style = `
  @Font-face {
    font-family: 'multiTitle';
    src: url(${multiTitleFontURL});
  }
  @Font-face {
    font-family: 'multiLeftButton';
    src: url(${multiLeftButtonFontURL});
  }
  @Font-face {
    font-family: 'multiRightButton';
    src: url(${multiRightButtonFontURL});
  }
    /* reset */
    * {
      box-sizing: border-box;
      margin: 0;
      padding: 0;
      list-style: none;
      text-decoration: none;
      
    }
    html,
    body {
      height: 100%;
      overflow: hidden;
    }
    main {
      height: 100%;
      position: relative;
    }
    a {
      color: #000000;
      cursor: pointer;
    }
    button {
      background: none;
      border: none;
    }

    /* custom */
    .root {
      width: 100%;
      height: 100%;

      overflow: hidden;
      position: relative;
      background: none
    }
    .background {
      width: 100%;
      height: 100%;

      position: absolute;
      top: 0;
      background: rgba(0, 0, 0, 0.8);
    }
    .center_wrapper {
      width: 100%;

      display: flex;
      flex-direction: column;
      gap: 1rem;

      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }

    .slick_wrapper,
    .slick_wrapper .slick-slider,
    .slick_wrapper .slick-list {
      width: 100%;
      height: 16rem;
    }
    .slick-track {
      position: relative;
    }
    .slick_wrapper .slick-list {
      // padding: 0 -0.5rem;
    }
    .slick_wrapper .slick-track {
      display: flex;
    }
    .slick_wrapper .slick-slide {
      margin: 0 0.5rem;
    }
    .slick_image_box {
      max-width: 16rem;
      min-width: 16rem;
      max-height: 16rem;
      min-height: 16rem;
      outline: 0;
    }
    .slick_image_box img {
      max-width: 16rem;
      min-width: 16rem;
      max-height: 16rem;
      min-height: 16rem;
      object-fit: cover;
      border-radius: ${radius?.multi_image}px;
    }

    .contents_wrapper {
      margin-top: 1rem;
      width: 100%;
      padding: 0 10%;

      display: flex;
      justify-content: center;
    }
    .contents_wrapper,
    .contents_wrapper .slick-slider,
    .contents_wrapper .slick-list,
    .contents_wrapper .slick-track div,
    .contents_wrapper .slick-track img {
      height: 4.5rem;
    }
    .contents_wrapper .slick-slider {
      width: 16rem;
    }

    .contents_box .title {
      width: 100%;
      height: 4rem;
      
      display: flex;
      align-items: center;
    }
    .title .title_inner {
      width: 100%;

      text-overflow: ellipsis;
      overflow: hidden;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;

      text-align: ${textAlign?.multi_title};
      color: ${color?.multi_title};
      font-size: ${fontSize?.multi_title}rem;
      font-weight: ${fontWeight?.multi_title};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          fontFamily?.multi_title
        )
          ? fontFamily?.multi_title
          : 'multiTitle'
      };
    }

    .slick-dots {
      margin-bottom: 6px;
    }
    .slick-dots li {
      width: 4px;
      height: 4px;
      transition: all ease 0.3s 0s;
    }
    .slick-dots .slick-active {
      width: 1.39rem;
    }
    .slick-dots li button {
      width: 4px;
      height: 4px;
      padding: 0;
      border-radius: 4px;
      background: rgb(196, 196, 196);
      opacity: 0.8;
      transition: all ease 0.3s 0s;
    }
    .slick-dots .slick-active button {
      width: 1.39rem;
      opacity: 1;
      background: rgb(230, 230, 230);
    }
    .slick-dots li button::before {
      width: 4px;
      height: 4px;
      padding: 0;
      display: none;
    }

    .btn_wrapper {
      width: 100%;
      height: 2rem;
      padding: 0 10%;

      display: flex;
      justify-content: center;
      align-items: center;
      gap: 0.5rem;
    }
    .btn_inner {
      width: 16rem;
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 0.5rem;
    }
    .btn_wrapper span {
      width: 100%;
    }

    .btn_wrapper .style01 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      
      font-size: ${btnFontSize?.multi_left_button}rem;
      font-weight: ${btnFontWeight?.multi_left_button};
      color: ${btnColor?.multi_left_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_left_button
        )
          ? btnFontFamily?.multi_left_button
          : 'multiLeftButton'
      };
      border-radius: ${radius?.multi_left_button}px;
      background-color:rgba(${btnBgColorR?.multi_left_button},${
    btnBgColorG?.multi_left_button
  }, ${btnBgColorB?.multi_left_button}, ${btnBgColorA?.multi_left_button});
    }
    .btn_wrapper .style02 {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      text-align: right;
      font-size: ${btnFontSize?.multi_right_button}rem;
      font-weight: ${btnFontWeight?.multi_right_button};
      color: ${btnColor?.multi_right_button};
      font-family: ${
        ['Roboto', 'Inter', 'Montserrat', 'Poppins', 'Pretendard'].includes(
          btnFontFamily?.multi_right_button
        )
          ? btnFontFamily?.multi_right_button
          : 'multiRightButton'
      };
      border-radius: ${radius?.multi_right_button}px;
      background-color:rgba(${btnBgColorR?.multi_right_button},${
    btnBgColorG?.multi_right_button
  }, ${btnBgColorB?.multi_right_button}, ${btnBgColorA?.multi_right_button});
    }

    @media screen and (max-width: 321.25px) {
      .slick_wrapper,
      .slick_wrapper .slick-slider,
      .slick_wrapper .slick-list {
        height: 14rem;
      }
      .slick_image_box,
      .slick_image_box img {
        max-width: 14rem;
        min-width: 14rem;
        max-height: 14rem;
        min-height: 14rem;
      }

      .contents_wrapper,
      .contents_wrapper .slick-slider,
      .contents_wrapper .slick-list,
      .contents_wrapper .slick-track div,
      .contents_wrapper .slick-track img {
        height: 4rem;
      }
      .contents_wrapper .slick-slider {
        width: 14rem;
      }
      .contents_box .title {
        height: 4rem;
        font-size: ${fontSize?.multi_title - 0.25}rem;
      }
      .title .title_inner {
        max-height: 3.4rem;
      }

      .btn_inner {
        width: 14rem;
      }
    }

		@media screen and (min-width: 608px) and (max-width: 1024px) {
      .slick_wrapper,
      .slick_wrapper .slick-slider,
      .slick_wrapper .slick-list {
        height: 24rem;
      }
      .slick_image_box, 
      .slick_image_box img {
        max-width: 24rem;
        min-width: 24rem;
        max-height: 24rem;
        min-height: 24rem;
      }

      .contents_wrapper,
      .contents_wrapper .slick-slider,
      .contents_wrapper .slick-list,
      .contents_wrapper .slick-track div,
      .contents_wrapper .slick-track img {
        height: 6rem;
      }
      .contents_wrapper .slick-slider {
        width: 24rem;
      }

      .contents_box .title {
        height: 6rem;
        font-size: ${fontSize?.multi_title + 0.25}rem;
      }
      .title .title_inner {
        max-height: 4.2rem;
      }

      .btn_inner {
        width: 24rem;
      }
      .btn_wrapper .style01 {
        font-size: ${btnFontSize?.multi_right_button + 0.125}rem;
      }
      .btn_wrapper .style02 {
        font-size: ${btnFontSize?.multi_left_button + 0.125}rem;
      }
    }
  `;

  const html = `
    <div class="root" id="test">
      <div class="background" onclick="appboyBridge.logClick('background'); appboyBridge.closeMessage();"></div>
      <div class="center_wrapper">
        <div class="slick_wrapper">
          <div class="slick_slider">${bgImage?.multi_image
            ?.map(
              (data: any, idx: number) => `<div class="slick_image_box">
            <img class="image" src="${
              !data || data === '' ? blackImageUrl : data
            }" alt="" />
          </div>`
            )
            .join('')}
          </div>
        </div>
        <div class="contents_wrapper">
          <div class="contents_slider">${text?.multi_title
            ?.map(
              (data: any, idx: number) => `<div class="contents_box">
            <div class="title">
              <span class="title_inner">
                ${changeEnterHTML(text?.multi_title?.[idx])}
              </span>
            </div>
          </div>`
            )
            .join('')}
          </div>
        </div>
        <div class="btn_wrapper">
          <div class="btn_inner">
            <span class="style01">${btnText?.multi_left_button}</span>
            <span class="style02">${btnText?.multi_right_button}</span>
          </div>
        </div>
      </div>
    </div>
  `;

  let deeplink_list = '[';
  for (let i = 0; i < deeplink?.multi_image?.length; i++) {
    deeplink_list += `'${deeplink?.multi_image?.[i]}'`;
    if (i !== deeplink?.multi_image?.length - 1) deeplink_list += ',';
  }
  deeplink_list += ']';

  let button_list = '[';
  for (let i = 0; i < btnText?.multi_left_button?.length; i++) {
    button_list += `['${btnText?.multi_left_button?.[i]}', '${btnText?.multi_right_button?.[i]}']`;
    if (i !== btnText?.multi_left_button?.length - 1) button_list += ',';
  }
  button_list += ']';

  let tracking_list = '[';
  for (let i = 0; i < tracking?.multi_image?.length; i++) {
    tracking_list += `['${tracking?.multi_image?.[i]}', '${tracking?.multi_left_button?.[i]}', '${tracking?.multi_right_button?.[i]}'],`;
  }
  tracking_list += ']';

  const tracking_button_list = trackingList(
    'SLIDE MODAL IMAGE',
    button1,
    button2
  );

  const js = `
    document.addEventListener("DOMContentLoaded", function(){
      $('.slick_slider').slick({
        arrows: false,
        dots: true,
  
        centerMode: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        speed: 300,
        touchThreshold: 300
      });
  
      $('.contents_slider').slick({
        arrows: false,
        dots: false,
        fade: true,
    
        speed: 300,
        swipe: false
      });

      let currentIndex = 0;
      let button = ${button_list};
      let tracking = ${tracking_list};
      let button1 = ${tracking_button_list[0]};
      let button2 = ${tracking_button_list[1]};
      $('.style01').text(button[currentIndex][0]);
      $('.style02').text(button[currentIndex][1]);
      $('.slick_slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
        currentIndex = $('.slick_slider').slick('slickCurrentSlide');
        $('.contents_slider').slick('goTo', currentIndex);
        $('.style01').text(button[currentIndex][0]);
        $('.style02').text(button[currentIndex][1]);
      });

      let deeplink = ${deeplink_list};
      $('.image').click(function() {
        appboyBridge.logClick(tracking[currentIndex][0]);
        try {
          if (button1[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[0].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = deeplink[currentIndex];
      });
      $('.style01').click(function() {
        appboyBridge.logClick(tracking[currentIndex][1]);
        try {
          if (button1[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[1].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        appboyBridge.closeMessage();
      });
      $('.style02').click(function() {
        appboyBridge.logClick(tracking[currentIndex][2]);
        try {
          if (button1[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('0');
          }
          if (button2[2].indexOf(currentIndex) !== -1) {
            appboyBridge.logClick('1');
          }
        } catch (err) {}
        window.location = deeplink[currentIndex];
      });
    });
  `;

  return (
    <>
      <head>
        <meta charSet="UTF-8" />
        <meta
          name="viewport"
          content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no"
        />

        {/* google font */}
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" />
        <link
          href="https://fonts.googleapis.com/css2?family=Roboto:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@300;400;500;600;700&display=swap"
          rel="stylesheet"
        />
        <link
          rel="stylesheet"
          as="style"
          href="https://cdn.jsdelivr.net/gh/orioncactus/pretendard@v1.3.9/dist/web/static/pretendard.min.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdn.jsdelivr.net/npm/normalize.css@8.0.1/normalize.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.css"
        />
        <link
          rel="stylesheet"
          type="text/css"
          href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick-theme.css"
        />
        <style dangerouslySetInnerHTML={{ __html: style }} />
      </head>
      <body dangerouslySetInnerHTML={{ __html: html }} />
      <script src="https://ajax.googleapis.com/ajax/libs/jquery/2.2.4/jquery.min.js" />
      <script src="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.8.1/slick.min.js" />
      <script dangerouslySetInnerHTML={{ __html: js }} />
    </>
  );
};
export default SlideModalImageHTML;
